export const TASK_NAME_SEARCH_ACCESSOR = "like.name";

export const TASK_SORTS = {
  CREATED_DESC: "CREATED_DESC",
  CREATED_ASC: "CREATED_ASC",
  DUE_ASC: "DUE_ASC",
  DUE_DESC: "DUE_DESC",
};

export const DEFAULT_TASK_SORT = TASK_SORTS.CREATED_DESC;

const TASK_SORT_ORDER_BY = {
  [TASK_SORTS.CREATED_DESC]: [{ createdDate: "DESC" }],
  [TASK_SORTS.CREATED_ASC]: [{ createdDate: "ASC" }],
  [TASK_SORTS.DUE_ASC]: [
    { event: { startDate: { order: "ASC", nulls: "NULLS LAST" } } },
    { createdDate: "DESC" },
  ],
  [TASK_SORTS.DUE_DESC]: [
    { event: { startDate: { order: "DESC", nulls: "NULLS LAST" } } },
    { createdDate: "DESC" },
  ],
};

export const taskSortOrderBy = (sort) =>
  TASK_SORT_ORDER_BY[sort] || TASK_SORT_ORDER_BY[DEFAULT_TASK_SORT];

export const buildTaskTitleSearchFilter = (searchValue) => ({
  accessor: TASK_NAME_SEARCH_ACCESSOR,
  value: `%${String(searchValue || "").trim()}%`,
});

export const withTaskSearchVars = (variables = {}, filter = {}) => {
  const next = { ...variables };
  if (filter.like) {
    next.like = filter.like;
  }
  if (filter.lt) {
    next.lt = filter.lt;
  }
  if (filter.gt) {
    next.gt = filter.gt;
  }
  return next;
};

export const resolveTaskEmptyMessage = ({
  hasSearch,
  searchEmptyMessage,
  listEmptyMessage,
}) => (hasSearch ? searchEmptyMessage : listEmptyMessage);
